import axios from 'axios'

// axios.defaults.baseURL = Vue.$appConfig.api_url // 'https://poliglotiki.ru/api/v1'
// axios.defaults.headers.common.Authorization = ''
axios.defaults.headers.post['Content-Type'] = 'application/json'

const api = (params) => {
  // const token = localStorage.getItem('user-token') || ''
  // const iduser = localStorage.getItem('iduser') || ''

  // if (process.env.NODE_ENV === 'development') axios.defaults.baseURL = 'http://localhost/poli/api/web/api/v1'

  return axios(params)
}

export default api
